import getSum from './summen';
import {grundbedarf_stud,grundbedarf_meister,grundbedarf_schule,grundbedarf_schule1} from './grundbedarf';
import {wohnzuschlagBerechnen} from './wohnzuschuss.js';
import {krankenzuschlagBerechnen} from './krankenkasse.js';
import {einkommenBerechnen} from './einkommen.js';
import {vermoegenBerechnen} from "./vermoegen.js";
import {schuldenBerechnen} from "./schulden.js";
import {kinderzuschlagBerechnen} from "./kinder.js";
import {elternBerechnen} from "./eltern.js";
import {meisterzuschlagBerechnen} from "./meister.js";

/** Globale Prüfung aller Eingaben
 *
 * @param $this
 */
function checkInput($this){
    if($this.el$('Ausbildung.art')){ // Ausbildung ausgewählt ?
        switch (checkAusbildung($this)) { // Prüfen, welche Ausbildung ausgewählt
            case 'student': // Student
                //console.log("Student")
                if(!zeitmodell($this) || stipendium($this)){
                    // In Teilzeit alles nullen
                    //console.log("Student berechnen nullen")
                    grundbedarf_stud($this,true)
                    berechneRest($this, true)
                }else{
                    //console.log("Student berechnen false")
                    grundbedarf_stud($this, false)
                    berechneRest($this, false)
                }
                break;
            case 'schuelermit': // Schüler mit Ausbildung vorausgesetzt
                if(!zeitmodell($this)  || stipendium($this)){
                    grundbedarf_schule($this, true)
                    berechneRest($this, true)
                }else{
                    grundbedarf_schule1($this, $this.el$('Ausbildung.divschulez').value)
                    berechneRest($this, false)
                }
                break;
            case 'schuelerohne': // Schüler ohne Ausbildung vorausgesetzt
                //console.log("Schüler ohne")
                if(!zeitmodell($this)  || stipendium($this) || schuelerOhneCheck($this) ){
                    //console.log("Schüler ohne berechnen nullen")
                    grundbedarf_schule($this, true)
                    berechneRest($this, true)
                }else{
                    //console.log("Schüler ohne berechnen false")
                    grundbedarf_schule($this, $this.el$('Ausbildung.divschule').value)
                    berechneRest($this, false)
                }
                break;
            case 'meister': // AufstiegsBAföG / Meister
                if(!zeitmodell($this)  || stipendium($this)){
                    grundbedarf_meister($this, zeitmodell($this), true)
                    berechneRest($this, true)
                }else{
                    grundbedarf_meister($this, zeitmodell($this), false)
                    berechneRest($this, false)
                }
                break;
            default: // alle Zahlen auf 0,00 setzen
                grundbedarf_schule($this, true)
                berechneRest($this, true)
                break;
        }
    }else{
        // Summen auf 0,00 setzen, da keine Ausbildung ausgewählt
        getSum($this, true, true, true)
    }
}

/** berechne Standard-Aufrufe
 *
 * @param $this
 * @param loeschen
 */
function berechneRest($this, loeschen = false){
    //console.log('rest berechnen')
    einkommenBerechnen($this, loeschen)
    vermoegenBerechnen($this, loeschen)
    schuldenBerechnen($this, loeschen)
    wohnzuschlagBerechnen($this,loeschen)
    krankenzuschlagBerechnen($this, loeschen)
    kinderzuschlagBerechnen($this, loeschen)
    elternBerechnen($this, loeschen)
    meisterzuschlagBerechnen($this, loeschen)
    // TODO Partner
    // TODO Ausland
    getSum($this, loeschen, loeschen, loeschen)
}

/** prüfen, ob Stipendium ausgewählt wurde
 *
 * @param $this
 * @returns {boolean}
 */
function stipendium($this){
    if (!$this.el$('Einkommen.art')) {
        //console.log('einkommen stipendium: true')
        return false
    }
    return !!$this.el$('Einkommen.art').value.includes(4);
}

/** prüfen, ob zeitmodell (vollzeit/Teilzeit) ausgewählt wurde
 *
 * @param $this
 * @returns {boolean}
 */
function zeitmodell($this){
    if (!$this.el$('Ausbildung.zeitmodell')) {
        //console.log('einkommen stipendium: true')
        return false
    }
    return $this.el$('Ausbildung.zeitmodell').value === 'vollzeit';
}

/**
 * Prüfe, ob Studi, Schüler mit Ausbildung, Schüler Ohne Ausbildung oder Meister
 * @param $this
 * @returns {string|number|*}
 */
function checkAusbildung($this){
    //console.log('checkausbildung: '+$this.el$('Ausbildung.art').value)
    if($this.el$('Ausbildung.art').value === 'student'){ // student
        return $this.el$('Ausbildung.art').value
    }else if($this.el$('Ausbildung.art').value === 'schueler'){ // schüler
        if($this.el$('Ausbildung.ausbildung_vorr').value === 'ja'){ // Ausbildung vorausgesetzt
            return $this.el$('Ausbildung.art').value+'mit'
        }else if($this.el$('Ausbildung.ausbildung_vorr').value === 'nein'){ // Ausbildung nicht vorausgesetzt
            return $this.el$('Ausbildung.art').value+'ohne'
        }else{ // Fehler
            return null
        }
    }else if($this.el$('Ausbildung.art').value === 'meister'){
        return $this.el$('Ausbildung.art').value
    }else{ // nichts
        return null;
    }
}

/**  Ausgabe in Europäisches Format umwandeln
 *
 * @param value
 * @returns {string}
 */
function formatPrice(value) {
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

/**  Ausgabe US-Format zurück umwandeln
 *
 * @param value
 * @returns {number}
 */
function formatPriceRev(value) {
    let val = value.replace('.', '')
    val = val.replace(',', '.')
    return parseFloat(val)
}

function schuelerOhneCheck($this){
    if($this.el$('Ausbildung.divschule').value === 'allg_schule') {
        if (!$this.el$('Ausbildung.beiEltern')) {
            //console.log('schuler: true')
            return false
        }

        return $this.el$('Ausbildung.beiEltern').value === 'ja';
    }
    return false
}

/**
 * Funktionen exportieren
 */
export {checkInput,formatPrice,formatPriceRev,checkAusbildung,zeitmodell};
